import { z } from 'zod';
import { ctaUrlSchema, localeSchema, slugSchema } from './content.js';
/* ── Products ──────────────────────────────────────────────────────────
 * What is on /produkty: self-paced courses, the bundle of them, and the
 * free materials that feed the mailing list. Same three-schema rule as
 * content.ts — patch schemas carry NO defaults.
 *
 * There is no checkout yet (decision log: payments are a placeholder), so
 * "Kup kurs" goes wherever Diana points it: her own link, Telegram from
 * settings, or the contact page.
 */
export const PRODUCT_KINDS = ['course', 'bundle', 'free'];
export const PRODUCT_KIND_LABELS = {
    course: 'Kurs',
    bundle: 'Pakiet kursów',
    free: 'Za darmo',
};
const productBase = z.object({
    locale: localeSchema,
    slug: slugSchema,
    kind: z.enum(PRODUCT_KINDS),
    title: z.string().min(1).max(120),
    subtitle: z.string().max(200),
    description: z.string(),
    /** "W cenie" / "W środku" bullets. */
    includes: z.array(z.string().min(1)),
    /** "A0 → A1", "B1–C2". Free text — Diana writes it the way she says it. */
    level: z.string().max(40),
    /** "3 miesiące". Free text for the same reason. */
    duration: z.string().max(80),
    /** Integer grosze. 0 = free. */
    priceGrosz: z.number().int().nonnegative(),
    /** The regular price a bundle is compared against; 0 = no comparison shown. */
    compareAtGrosz: z.number().int().nonnegative(),
    /** Tag on the card: "Najlepsza cena". Shown when the product is featured. */
    badge: z.string().max(40),
    ctaLabel: z.string().max(60),
    ctaUrl: ctaUrlSchema,
    coverImageId: z.uuid().nullable(),
    order: z.number().int(),
    active: z.boolean(),
    featured: z.boolean(),
});
export const productInputSchema = productBase.extend({
    kind: productBase.shape.kind.default('course'),
    subtitle: productBase.shape.subtitle.default(''),
    description: productBase.shape.description.default(''),
    includes: productBase.shape.includes.default([]),
    level: productBase.shape.level.default(''),
    duration: productBase.shape.duration.default(''),
    priceGrosz: productBase.shape.priceGrosz.default(0),
    compareAtGrosz: productBase.shape.compareAtGrosz.default(0),
    badge: productBase.shape.badge.default(''),
    ctaLabel: productBase.shape.ctaLabel.default(''),
    ctaUrl: productBase.shape.ctaUrl.default(''),
    coverImageId: productBase.shape.coverImageId.default(null),
    order: productBase.shape.order.default(0),
    active: productBase.shape.active.default(true),
    featured: productBase.shape.featured.default(false),
});
/** No defaults — an absent key means "leave it alone". */
export const productPatchSchema = productBase.partial();
export const productSchema = productInputSchema.extend({
    id: z.uuid(),
    coverUrl: z.string().nullable().default(null),
});
